import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Link, CircularProgress, Typography } from "@mui/material";
import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

const FAQTable = ({ formType }) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  const userInfo = Digit?.UserService?.getUser()?.info || {};
  const isEmployee = userInfo?.type === "EMPLOYEE";
  const filteredTableData = isEmployee
    ? tableData.filter((row) => row?.typeOfUser === "Department Only")
    : tableData.filter((row) => row?.typeOfUser !== "Department Only");

  const fetchManualData = async () => {
    try {
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01",
        },
      };

      const response = await axios.post(`${Urls.UserManualSearch}?isApproved=${formType}&isSubApproved=FAQ`, dataToSend);

      console.log("📘 Response From FAQ API:", response.data);

      // ✅ Fix: Map correct key
      setTableData(response.data?.UserManual || []);
    } catch (error) {
      console.error("❌ Error fetching FAQ data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManualData();
  }, [formType]);

  if (loading) {
    return (
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 180,
          backgroundColor: "#f8fafc",
        }}
      >
        <CircularProgress size={28} sx={{ color: "#0c5a88" }} />
        <Typography sx={{ ml: 2, color: "#0c5a88" }}>Loading documents...</Typography>
      </Paper>
    );
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: 300,
        overflow: "auto",
        borderRadius: 2,
        boxShadow: 1,
      }}
    >
      <Table size="small">
        <TableHead sx={{ backgroundColor: "#e0edf8" }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>S.No.</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>FAQ</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Updated On</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Download Link</TableCell>
            {/* <TableCell sx={{ fontWeight: 600 }}>isApproval</TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {filteredTableData.length > 0 ? (
            filteredTableData.map((row, index) => (
              <TableRow key={row.id || index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.category || "—"}</TableCell>
                <TableCell>{row.isSubApproved || "—"}</TableCell>
                <TableCell>{row.description || "—"}</TableCell>

                {/* Convert createdTime to readable date */}
                <TableCell>{row.auditDetails?.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"}</TableCell>

                <TableCell>
                  {row.downloadLink ? (
                    <Link href={row.downloadLink} target="_blank" rel="noopener" sx={{ color: "#0c5a88", fontWeight: 500 }}>
                      Download
                    </Link>
                  ) : (
                    "—"
                  )}
                </TableCell>

                {/* <TableCell>
                  {row.isApproved === "manual" ? "Yes" : "No"}
                </TableCell> */}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FAQTable;
